import { Routes, Route, Navigate } from "react-router-dom";
import { Suspense } from "react";

import AuthRoute from "Components/AuthRoutes";

import WrappedPaymentForm from "Pages/stripe/WrappedPaymentForm";

import {
    CreatorsLandingPage,
    LandingPage
} from "Pages/landing";

import {
    About,
    Learn,
    ContactUs,
    PrivacyPolicy,
    TermsConditions
} from "Pages/Information";

import {
    Collaboration,
    CollaborationDetails,
} from "Pages/collaboration";

import {
    ForgotPassword as ForgotPasswordPage,
    OtpVerification,
    UpdatePasswordSuccess,
} from "Pages/auth";

// import { VitrineLive } from "./Pages/Live";

import {
    Campaigns,
    AddCampaigns,
    SingleCampaignDetails,
    CampaignDetailsSection,
    EditCampaign,
    EditCampaignV1,
} from "Pages/campaign/band";
import {
    CreatorCampaigns,
} from "Pages/campaign/creator";

import {
    Welcome,
    BrandCatalogue,
    CreatorDetails,
    BrandCompleteProfile,
    // BrandChat 
} from "Pages/bands";

import {
    Profile,
    BrandDetails,
    BrandDetailsV2,
    BrandDetailsV3,
    Setting,
} from "Pages/profile/band";

import {
    CreatorCompleteProfile,
    CreatorCompleteProfileV1,
    CreatorsProfile,
    CreatorsSetting,
} from "Pages/profile/creator";

import {
    CreatorsCatalogue,
    CatalogueDetails,
    AgencyInvite
} from "Pages/creators";

import {
    Packs, CreatePack, EditPack, PackDetails,
    PackDetailsV2,
    EditPackV1
} from "Pages/packages/creator";

import {
    CreatorChat,
} from "Pages/messages"


import { MainHelpView, BrandHelpCenter, CreatorsHelpCenter } from "Pages/help";
import OnboardingSuccess from "Pages/stripe/OnboardingSuccess";
import OnboardingFailed from "Pages/stripe/OnboardingFailed";
import { Help, HelpLanding, SignupHelp, DemoHelp } from "Pages/helpDocument";

import LoadingSpinner from "Components/common/loading/LoadingSpinner";

function AppRoutes() {

    console.log('Troy.....')

    const publicRoutes = [
        // Landing
        // { path: "/", element: <LandingPage /> },
        { path: "/landingPage", element: <LandingPage /> },

        { path: "/", element: <CreatorsLandingPage /> },
        // Auth
        { path: "/forgot-password", element: <ForgotPasswordPage /> },
        { path: "/update-password-success", element: <UpdatePasswordSuccess /> },
        { path: "/otpVerification", element: <OtpVerification /> },
        // Information
        { path: "/contactUs", element: <ContactUs /> },
        { path: "/about", element: <About /> },
        { path: "/learn", element: <Learn /> },
        { path: "/privacy-policy", element: <PrivacyPolicy /> },
        { path: "/termsAndConditions", element: <TermsConditions /> },
        // Help
        { path: "/brandHelp", element: <BrandHelpCenter /> },
        { path: "/creatorsHelp", element: <CreatorsHelpCenter /> },
        { path: "/mainHelp", element: <MainHelpView /> },
        //
        // { path: "/help", element: <Help /> },
        { path: "/help", element: <HelpLanding /> },
        { path: "/help/signup", element: <SignupHelp /> },
        { path: "/help/demo", element: <DemoHelp /> },
        // <Route path="/help" element={<HelpLanding />} />,
        // <Route path="/help/signup" element={<Help />} /> // đây là trang chi tiết từng mục
    ];

    const authenticatedRoutes = [
        // Campaigns (Brand)
        { path: "/myCampaigns", element: <Campaigns /> }, // My Campaigns
        { path: "/campaignDetailsSection", element: <CampaignDetailsSection /> },
        { path: "/addCampaigns", element: <AddCampaigns /> },
        // { path: "/edit-campaign", element: <EditCampaign /> },
        { path: "/edit-campaign", element: <AddCampaigns isEdit /> },
        { path: "/edit-campaign-v1", element: <EditCampaignV1 /> },
        // Campaigns (Creator)
        { path: "/creatorCampaigns", element: <CreatorCampaigns /> }, // Campaigns
        //
        { path: "/singleCampaignDetails", element: <SingleCampaignDetails /> },
        // --------
        // Brands
        { path: "/brandCatalogue", element: <BrandCatalogue /> }, // Other Bands (Band) or Bands (Creator)
        // --------
        // Creators
        { path: "/creatorsCatalogue", element: <CreatorsCatalogue /> }, // Creators (Band) or Other Creators (Creator)
        // --------
        // Packages (Creator)
        { path: "/packs/view", element: <Packs /> },
        { path: "/pack/create", element: <CreatePack /> },
        { path: "/pack/edit", element: <EditPack /> },
        { path: "/pack/editV1", element: <EditPackV1 /> },
        { path: "/pack/detailsV1", element: <PackDetails /> },
        { path: "/pack/details", element: <PackDetailsV2 /> },
        // --------
        // Messages
        { path: "/creatorChat", element: <CreatorChat /> },
        // Collaboration
        { path: "/collabration", element: <Collaboration /> },
        { path: "/collabrationDetails", element: <CollaborationDetails /> },
        // Other Page 
        { path: "/welcome", element: <Welcome /> },
        { path: "/creatorsCatalogueDetails", element: <CatalogueDetails /> }, // Developent is going on.. ?
        { path: "/agencyInvite", element: <AgencyInvite /> },
        { path: "/stripe-payment", element: <WrappedPaymentForm /> },
        // --------
        // Profile (Band)
        { path: "/brandProfile", element: <Profile /> },
        { path: "/brandCompleteProfile", element: <BrandCompleteProfile /> },
        // { path: "/brandDetails", element: <BrandDetails /> },
        { path: "/brandDetails", element: <BrandDetailsV3 /> },
        { path: "/brandDetailsV1", element: <BrandDetails /> },
        { path: "/brandDetailsV2", element: <BrandDetailsV2 /> },
        { path: "/brandSetting", element: <Setting /> },
        // Profile (Creator)
        { path: "/creatorsProfile", element: <CreatorsProfile /> },
        { path: "/creatorCompleteProfile", element: <CreatorCompleteProfile /> },
        { path: "/creatorCompleteProfileV1", element: < CreatorCompleteProfileV1 /> },
        //
        { path: "/creatorDetails/:creatorId", element: <CreatorDetails /> },
        { path: "/creatorsSetting", element: <CreatorsSetting /> },
        { path: "/onboarding-success", element: <OnboardingSuccess /> },
        { path: "/onboarding-failed", element: <OnboardingFailed /> },
    ];

    return (
        <Suspense fallback={<LoadingSpinner />}>
            <Routes>
                {publicRoutes.map(({ path, element }) => (
                    <Route key={path} path={path} element={element} />
                ))}

                {authenticatedRoutes.map(({ path, element }) => (
                    <Route key={path} path={path} element={<AuthRoute>{element}</AuthRoute>} />
                ))}

                {/* Path for Adding a redirect to show popup */}
                <Route path="/signup/brand" element={<Navigate to="/?signup=brand" />} />
                <Route path="/signup/creator" element={<Navigate to="/?signup=creator" />} />

                {/* Redirect all undefined routes to home */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Suspense>
    );
}

export default AppRoutes;
